import { JOB_STATUS, JOB_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueGetterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * jobStatusの値からフィルタ用の文字列を生成する（valueはnull/'0'/'1'/'2'/'3'）。
 * 0: 実行待 1: 実行中 2: 停止済 3: 完了とする。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const jobStatusFilterValueGetter = (params: ValueGetterParams) => {
  const value: string = params.getValue('jobStatus');
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const filterValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? JOB_STATUS_JA[value] : JOB_STATUS[value]) : value;
  return filterValue;
};

export default jobStatusFilterValueGetter;
